import { z } from 'zod';
export const createUserSchema = z.object({
    name: z.string().trim().min(1),
    email: z.string().trim().email(),
    password: z.string().min(8),
    role: z.string().min(1),
});
export const updateProfileSchema = z.object({
    name: z.string().trim().min(1).optional(),
    phone: z.string().optional(),
    preferences: z.record(z.unknown()).optional(),
});
//# sourceMappingURL=user.schemas.js.map